export default "__VITE_ASSET__BUu0s5vk__"